// @flow

import type { Action } from "redux-action";
import { beginRequest, completeRequest } from "@store/utils";

import type { PagesState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

// Events Page

export const onGetEventsCount = (state: PagesState) => () => startRequest(state);
export const onGetEventsCountSuccess = (state: PagesState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  eventsPage: payload,
});
export const onGetEventsCountError = (state: PagesState) => () => finishRequest(state);

// Classifications Page
export const onGetClassificationsCount = (state: PagesState) => () => startRequest(state);
export const onGetClassificationsCountSuccess = (state: PagesState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  classificationsPage: payload,
});
export const onGetClassificationsCountError = (state: PagesState) => () => finishRequest(state);

// Prompts Page
export const onGetPromptsCount = (state: PagesState) => () => startRequest(state);
export const onGetPromptsCountSuccess = (state: PagesState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  promptsPage: payload,
});
export const onGetPromptsCountError = (state: PagesState) => () => finishRequest(state);
